import { CommonDialogs } from "@mcleod/common";
import { AutogenLayoutSalesCallMultiSelectErrorModal } from "./autogen/AutogenLayoutSalesCallMultiSelectErrorModal";
import { Layout, TableRow, Dialog, Component } from "@mcleod/components";
import { SalesCallMultiSelectErrorSlideout } from "./SalesCallMultiSelectErrorSlideout";

const layoutPath = "lme/general/SalesCallMultiSelectErrorModal"

export class SalesCallMultiSelectErrorModal extends AutogenLayoutSalesCallMultiSelectErrorModal {
    public static async showModal(allRows: TableRow[], failedRows: TableRow[], successCount: number, title: string, addlComponents?: Component[]) {
        const modalLayout = Layout.getLayout(layoutPath) as SalesCallMultiSelectErrorModal;
        const modal = CommonDialogs.createDialog(modalLayout, {
            centerInParent: true,
            title,
            panelTitleProps:{
                backgroundColor: "primary.darker",
                color: "primary.reverse"
            },
            movable: true
        })
        modalLayout.addLayoutDataLoadListener(() => {
            if (addlComponents) {
                modalLayout.add(...addlComponents);
            }
            modalLayout.labelSuccessfulOrderCount.text = successCount.toString();
            const failedCount = failedRows.length;
            modalLayout.labelFailedOrderCount.text = failedCount.toString();
            if (failedCount > 0) {
                modalLayout.labelFailedOrderCount.color = "error";
                modalLayout.labelFailedLink.addClickListener(() =>
                    SalesCallMultiSelectErrorSlideout.showSlideout(failedRows));
            }
            else {
                modalLayout.labelFailedLink.visible = modalLayout.labelFailedPipe.visible = false;
            }
        });
        modal.show().then((message) => {
            allRows[0]?.table.dataSource.search(allRows[0].table.dataSource.lastSearch);
        });
    }
}
